import 'reflect-metadata';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ISwiperSlides, ISwiperOptions, ISwiper } from '@/types';
import { SwiperOptions } from './InitOptions';

@Component
export default class Otpions extends Vue implements Pick<ISwiper, 'options' | 'slides' | 'imageKey' | 'initOptions'> {
  @Prop({type: Array, default: () => []}) public readonly slides!: ISwiperSlides[];
  @Prop({type: Object, default: () => {}}) public readonly options!: SwiperOptions;
  @Prop({type: String, default: 'file'}) public readonly imageKey!: string;

  public readonly initOptions: ISwiperOptions = new SwiperOptions();
}

